import { Injectable } from '@angular/core';

/**
 * Blocks all in-app router navigation away from a popout route.
 *
 * Popout windows are dedicated, single-purpose child windows (conversations,
 * task table, send-email, …). The only way to leave one is to close the window,
 * so this guard denies every deactivation attempt — the popout route can never
 * be navigated to a different route within the same window.
 */
@Injectable({ providedIn: 'root' })
export class PopoutRouteLockGuard {
  canDeactivate(): boolean {
    return false;
  }
}
